import { handleActions } from 'redux-actions';
import { clearStatementPageStoreAction } from 'store/actions/statement-content-actions';
import {
  contentSectionMapLoading,
  contentSectionMapLoaded,
  contentSectionMapError,
} from 'store/actions/section-cache-actions';
import { ContentSectionMap } from 'models/api/content-section-map-api-model';
export default handleActions(
  {
    [contentSectionMapLoading]: (contentSectionMap) => {
      return contentSectionMap.setLoading();
    },
    [contentSectionMapLoaded]: (contentSectionMap, { payload }) => {
      return contentSectionMap.setLoaded(payload);
    },
    [contentSectionMapError]: (contentSectionMap, { payload }) => {
      return contentSectionMap.setError(payload);
    },

    [clearStatementPageStoreAction]: (contentSectionMap, { payload }) => {
      return new ContentSectionMap();
    },
  },
  new ContentSectionMap(),
);
